import React from 'react';

import { MainCard, PermissionsButtonWrapper, Text } from '~/components/core';
import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import SortableTable from '~/components/core/Tables/SortableTable';
import { PencilIcon } from '~/components/icons';

import { TEXTS } from './texts';
import type { CapacitySlotType } from './types';

function CapacityAgreementSlots({
  slots,
  onEditSlotClick,
}: {
  slots: CapacitySlotType[];
  onEditSlotClick: (capacitySlot: CapacitySlotType) => void;
}) {
  const columns = [
    {
      id: 'slot_name',
      label: TEXTS.slotsFieldLabels.slot_name,
    },
    {
      id: 'details',
      label: TEXTS.slotsFieldLabels.details,
      disableSort: true,
      maxWidthPercentage: 50,
      overflow: true,
    },
    {
      id: 'actions',
      label: TEXTS.actions,
      disableSort: true,
      width: 60,
      specialCell: (slot: CapacitySlotType) => (
        <PermissionsButtonWrapper>
          <IconButton key={slot.id} onClick={() => onEditSlotClick(slot)}>
            <PencilIcon />
            <span className="sr-only">{TEXTS.edit}</span>
          </IconButton>
        </PermissionsButtonWrapper>
      ),
    },
  ];

  const title = (
    <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
      {TEXTS.slotsTitle()}
    </Text>
  );
  return (
    <MainCard type="contained" className="border-slate-500 px-16 py-12" collapsible title={title}>
      {slots.length > 0 ? (
        <SortableTable columns={columns} rows={slots} />
      ) : (
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
          {TEXTS.noSlots()}
        </Text>
      )}
    </MainCard>
  );
}

export default CapacityAgreementSlots;
